
import * as angular from 'angular';

export function initializeMdMenuEventHandlers($rootScope, $mdMenu, $timeout) {
    'ngInject';
    // setup an event listener when menus open and query for the first mw-menu-item, if it exists, focus it.
    $rootScope.$on('$mdMenuOpen', function(event, el) {
        $timeout(function() {
            // This query is gross, we might want to spend some time at some point to make it simpler
            let focusElement = <HTMLElement> document.querySelector('.md-open-menu-container.md-active > md-menu-content mw-menu-item.md-autofocus > md-list-item > div > .md-button');

            if (focusElement) {
                focusElement.focus();
            }
        }, 100);

        $timeout(function() {
            let menuElement = document.querySelector('.md-open-menu-container.md-active');
            if (menuElement) {
                angular.element(menuElement).addClass('md-menu-animation-complete');
            }
        }, 200);
    });

    $rootScope.$on('$mdMenuClose', function(event, el) {
        $timeout(function() {
            let menuElement = document.querySelector('.md-open-menu-container.md-menu-animation-complete');
            if (menuElement) {
                angular.element(menuElement).removeClass('md-menu-animation-complete');
            }
        }, 200);
    });
}




// WEBPACK FOOTER //
// ./src/lib/components/menu/menu.config.ts